import { useWizardToast } from "./use-wizard-toast";
import { WizardToastView } from "./view-wizard-toast";
import type { WizardToastProps } from "./types-wizard-toast";

export function WizardToast(props: WizardToastProps) {
  const vm = useWizardToast();

  return <WizardToastView {...props} {...vm} />;
}

export type * from "./types-wizard-toast";
